<template>
    <vx-card title="Theories">
        <div id="viewTheoryLoadingDiv" class="vs-con-loading__container">
            <vs-table :sst="true"
                @search="handleSearch"
                @change-page="handleChangePage"
                @sort="handleSort"
                v-model="selected"
            
                :data="theories">

                <template slot="header">
                    <div class="flex flex-wrap items-center w-full mb-2">
                        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addTheory">Add a Theory</vs-button>
                    </div>
                </template>

                <template slot="thead">
                    <vs-th >Name</vs-th>
                    <vs-th >Image</vs-th>
                    <!-- <vs-th >Description</vs-th> -->
                    <vs-th >Action</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                            {{data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].image">
                            <img width="50" :src="data[indextr].image_path">
                        </vs-td>
                       <!--  <vs-td :data="data[indextr].description" style="max-width: 500px;max-height: 300px;">
                            <div v-html="data[indextr].description" style="max-width: 500px;max-height: 300px;"></div>
                        </vs-td> -->
                        <vs-td>
                            <vs-row>
                                <vs-button @click="editTheory(data[indextr])" class="mr-2" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                                <vs-button @click="deleteTheory(data[indextr])" color="danger" type="filled" icon-pack="feather" icon="icon-trash"></vs-button>
                            </vs-row>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <vs-popup  classContent="popup-example h-full" title="Add Theory" :active.sync="activePromptAddTheory">
                <div id="createTheoryLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="addTheoryForm">
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" label="Theory name" name="name" v-model="create_sign.name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('addTheoryForm.name')">{{ errors.first('addTheoryForm.name') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full mb-2">
                               <VueFileAgent
                                name="image"
                                ref="vueFileAgendsdt"
                                v-validate="'required'"
                                :theme="'list'"
                                :multiple="false"
                                :deletable="true"
                                :meta="true"
                                :compact="true"
                                :accept="'image/*'"
                                :maxSize="'5MB'"
                                :helpText="'Choose Theory Image'"
                                :errorText="{
                                  type: 'Invalid file type. Only image Allowed',
                                  size: 'Files should not exceed 5MB in size',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="image"
                              ></VueFileAgent>
                              <span class="text-danger text-sm" v-show="errors.has('addTheoryForm.image')">{{ errors.first('addTheoryForm.image') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full">
                                Description
                                <quill-editor v-model="create_sign.description"></quill-editor>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="createTheory()" color="primary" type="filled">Save Theory</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <vs-popup  classContent="popup-example h-full" title="Edit Theory" :active.sync="activePromptEditTheory">
                <div id="editTheoryLoadingDiv" class="vs-con-loading__container">
                    <form data-vv-scope="editTheoryForm">
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full mb-2">
                                <vs-input v-validate="'required'" label="Theory name" name="name" v-model="update_sign.name" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('editTheoryForm.name')">{{ errors.first('editTheoryForm.name') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full mb-2">
                               <VueFileAgent
                                name="image"
                                ref="vueFileAgendsdt"
                                v-validate="''"
                                :theme="'list'"
                                :multiple="false"
                                :deletable="true"
                                :meta="true"
                                :compact="true"
                                :accept="'image/*'"
                                :maxSize="'5MB'"
                                :helpText="'Choose Theory Image'"
                                :errorText="{
                                  type: 'Invalid file type. Only image Allowed',
                                  size: 'Files should not exceed 5MB in size',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="image"
                              ></VueFileAgent>
                              <span class="text-danger text-sm" v-show="errors.has('editTheoryForm.image')">{{ errors.first('editTheoryForm.image') }}</span>
                            </div>
                        </div>

                        <div class="vx-row mb-4">
                            <div class="vx-col sm:w-full">
                                Description
                                <quill-editor v-model="update_sign.description"></quill-editor>
                            </div>
                        </div>

                        <div align="right" class="vx-row">
                            <div  class="vx-col w-full mb-2">
                                <vs-button  v-on:click.prevent="updateTheory()" color="primary" type="filled">Update Theory</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </vs-popup>

            <div class="vx-row mt-base">
                <div class="vx-col w-full mb-2">
                    <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        vSelect,
        Treeselect,
        quillEditor,
    },
    data() {
        return {
            selected:[],
            key : null, 
            active : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            theories: [],
            deleteTheoryData : null,
            selected_place_name : null,
            selected_place_location : null,
            selected_place_type : "all",
            place_types : [
                { id : 'all', label : 'All' },
                { id : 'place', label : 'Theory' },
                { id : 'event', label : 'Event' },
                { id : 'tip', label : 'Tip' },
            ],
            activePromptAddTheory : false,
            activePromptEditTheory : false,
            image : [],
            fileRecordsForUpload: [],
            create_sign : {
                name : null,
                description : null,
                status : true,
            },
            update_sign : {
                id : null,
                name : null,
                description : null,
                status : true,
            },
            theoriesPopUp : false

        }
    },
    watch: {
        currentPage(val) {
            this.searchTheories()
        }
    },
    async mounted() {
        await this.viewTheories() 
        this.theories = this.$store.state.questionManagement.theories
    },
    computed: {
        sign_categories_options(){
            let signCategories = this.$store.state.questionManagement.sign_categories
            // console.log(signCategories)
            let signCategoriesData = []

            signCategories.forEach(function(entry, key) {
                signCategoriesData.push({
                    id : entry.id,
                    title : entry.name,
                    label : entry.name,
                })
            });

            return signCategoriesData
        },
    },
    methods: {
        manageTheories(){
            this.theoriesPopUp = true
        },
        redirectToAppPath(path){
            window.open(path, "_blank");
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
            // queued file, not yet uploaded. Just remove from the arrays
              this.fileRecordsForUpload.splice(i, 1);
              var k = this.image.indexOf(fileRecord);
              if (k !== -1) this.image.splice(k, 1);
            } else {
              this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        addTheory() {
            this.image = [];
            this.fileRecordsForUpload = [];
            this.activePromptAddTheory = true;
        },
        createTheory(){
            this.$validator.validateAll('addTheoryForm').then(result => {
                if (result) this.createTheoryApi()
            })
        },
        createTheoryApi(){
            var self = this 
            this.$vs.loading({
              container: '#createTheoryLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('name', this.create_sign.name);
            data.append('description', this.create_sign.description);
            if(this.image.length) data.append('image', this.image[0].file);

            this.$store.dispatch("questionManagement/createTheory", data)
                .then(res => { 
                    this.$vs.loading.close('#createTheoryLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Theory created successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.fileRecordsForUpload = [];
                    this.activePromptAddTheory = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#createTheoryLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "addTheoryForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        editTheory(sign) {
            this.update_sign = sign;
            this.image = [];
            this.fileRecordsForUpload = [];
            this.activePromptEditTheory = true
        },
        updateTheory(){
            this.$validator.validateAll('editTheoryForm').then(result => {
                if (result) this.updateTheoryApi()
            })
        },
        updateTheoryApi(){
            var self = this 
            this.$vs.loading({
              container: '#editTheoryLoadingDiv',
              scale: 0.6
            })

            let data = new FormData();
            data.append('id', this.update_sign.id);
            data.append('name', this.update_sign.name);
            data.append('description', this.update_sign.description);
            if(this.image.length) data.append('image', this.image[0].file);

            this.$store.dispatch("questionManagement/updateTheory", data)
                .then(res => { 
                    this.$vs.loading.close('#editTheoryLoadingDiv > .con-vs-loading')
                    this.$vs.notify({
                        title: "Success.",
                        text: "Theory updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.image = [];
                    this.fileRecordsForUpload = [];
                    this.activePromptEditTheory = false;
                })
                .catch(err => { 
                    this.$vs.loading.close('#editTheoryLoadingDiv > .con-vs-loading')

                    Object.keys(err.data.errors).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            scope: "editTheoryForm",
                            msg: err.data.errors[key][0],
                        });
                    });
                })
        },
        deleteTheory(place) {
            this.deleteTheoryData = place;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this data ?',
                accept: this.acceptDeleteTheory
            })
        },
        acceptDeleteTheory() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteTheory", { id : this.deleteTheoryData.id})
                .then(res => { 
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Theory deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });
                })
                .catch(err => { 
                  this.$vs.loading.close()
                })
        },
        
        
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchTheories()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchTheories()
            }
        },
        async searchTheories() {
            var self = this
            this.$vs.loading({
                container: '#viewTheoryLoadingDiv',
                scale: 0.6
            })

            let data = { 
                name : this.selected_place_name, 
                location : this.selected_place_location, 
                sort : this.key, 
                sort_key : this.active, 
                page : this.currentPage,
                place_type : this.selected_place_type,
            }

            await this.$store.dispatch("questionManagement/viewTheory", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewTheoryLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewTheoryLoadingDiv > .con-vs-loading')
                })

                this.theories = this.$store.state.questionManagement.theories
        },
        async viewTheories() {
            var self = this

            await this.$store.dispatch("questionManagement/viewTheory", {page : this.currentPage})
                .then(res => { 
                    this.totalPage = res.data.last_page
                })

            this.theories = this.$store.state.questionManagement.theories
        },
    },
    async created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }
    },
}
</script>
<style type="text/css">
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.vs-con-textarea{
    height: 400px;
}

.vs-textarea {
    height: 100%;
}

.categories_popup .vs-popup{
    width: 700px !important;
}

</style>

